import { UiFlagsStore } from "../stores/uiFlagsStore";
import { Environment } from "./envinonment";

const hogaApiUrls = {
    prod: "https://ck2api-sobol.fasttrack.tuz.pl/Service/GetDaneHoga",
    test: "https://ck2api-sobol.uat.fasttrack.tuz.pl/Service/GetDaneHoga"
};

export enum ApiUrls {
    calculation = "calculation",
    proposal = "proposal",
    policy = "policy",
    generateClientEndsLink = "generateClientEndsLink",
    pdf = "pdf",
    paymentFormPdf = "paymentForm",
    risksNetwork = "calculateRiskAvailability",
    storeCalculation = "calculations/store",
    retrieveCalculation = "calculations/retrieve",
    retrieveContractForRenewalById = "calculations/retrieveContractForRenewal/byContractId",
    retrieveContractForRenewalBySeriesAndNumber = "calculations/retrieveContractForRenewal/byNumberAndSeries",
    authorizeRetrieveContractForRenewal = "policyRenewalOffer/authorize/",
    getPolicyRenewalData = "policyRenewalOffer/policy?authorizedPolicyRenewalOfferId=",
    banks = "dictionaries/banks",
    paymentMethods = "dictionaries/availablePaymentMethods",
    generateRemotePaymentLink = "generateRemotePaymentLink",
    sendForApproval = "uw-rules/send-for-approval/"
}

export class Api {
    public static getUrl(uiFlagsStore: UiFlagsStore, endpoint: ApiUrls) {
        return `${uiFlagsStore.apiDomain}${endpoint}`;
    }

    public static getHogaUrl(uiFlagsStore: UiFlagsStore) {
        if (Environment.checkIfTestOrLocalhostEnvironment(uiFlagsStore)) {
            return hogaApiUrls.test;
        }

        return hogaApiUrls.prod;
    }
}
